import { memo, type ComponentType } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Skeleton } from "@design-system/Skeleton/Skeleton";
import { getAccrualDocumentImportStatus } from "./accrualImporter.helpers";
import { AccrualImporterViewRow } from "./accrualImporter.types";
import styles from "./AccrualDocumentImporter.module.scss";

type AccrualImporterCellProps = CellContext<
    ViewTableFeatures,
    AccrualImporterViewRow,
    unknown
>;

function isRowExtracting(row: AccrualImporterViewRow) {
    if (row.isPlaceholder || row.groupLabel) {
        return false;
    }
    const { kind } = getAccrualDocumentImportStatus({
        id: row.documentRowId ?? row.id,
        file: row.file,
        financialDocument: row.financialDocument,
    });
    return kind === "uploading" || kind === "processing";
}

export function withExtractingSkeleton(
    Cell: ComponentType<AccrualImporterCellProps>,
) {
    return memo((props: AccrualImporterCellProps) =>
        isRowExtracting(props.row.original) ? (
            <ViewTableCell className={styles.skeletonCell}>
                <Skeleton animation="wave" width="100%" height={20} />
            </ViewTableCell>
        ) : (
            <Cell {...props} />
        ),
    );
}
